import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import SchufaPage from "./pages/SchufaPage";
import PhoneVerifyPage from "./pages/PhoneVerifyPage";
import RegisterSetPassword from "./pages/RegisterSetPassword";
import ConfirmPage from "./pages/ConfirmPage";
import ResetPage from "./pages/ResetPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import NutzungsbedingungenPage from "./pages/NutzungsbedingungenPage";
import BarrierefreiheitPage from "./pages/BarrierefreiheitPage";
import TeilnahmebedingungenTreueprogrammPage from "./pages/TeilnahmebedingungenTreueprogrammPage";
import Footer from "./components/Footer";
import Maintenance from "./pages/Maintenance";
import Migrate from "./pages/Migrate";

const MAINTENANCE_MODE = import.meta.env.VITE_MAINTENANCE_MODE === "true";

const TEST_SCHUFA = false; // Set to true to skip the guard and directly test the SchufaPage component
const TEST_PHONE = false; // Set to true to skip the guard and directly test the PhoneVerifyPage component

function App() {
  if (MAINTENANCE_MODE) {
    return (
      <Router>
        <Routes>
          <Route path="*" element={<Maintenance />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={TEST_PHONE ? <PhoneVerifyPage /> : TEST_SCHUFA ? <SchufaPage skipGuard /> : <Login />} />
          <Route path="/login" element={<Login />} />
          <Route path="/migrate" element={<Migrate />} />
          <Route path="/register" element={<Register />} />
          <Route path="/c/:campaign/:referral?" element={<Register />} />
          <Route path="/verify/schufa" element={<SchufaPage />} />
          <Route path="/verify/phone" element={<PhoneVerifyPage />} />
          <Route path="/register/set-password" element={<RegisterSetPassword />} />
          <Route path="/confirm" element={<ConfirmPage />} />
          <Route path="/reset-password" element={<ResetPage />} />
          <Route path="/set-password" element={<SetPasswordPage />} />
          <Route path="/legal/impressum" element={<ImpressumPage />} />
          <Route path="/legal/datenschutz" element={<DatenschutzPage />} />
          <Route path="/legal/nutzungsbedingungen" element={<NutzungsbedingungenPage />} />
          <Route path="/legal/barrierefreiheit" element={<BarrierefreiheitPage />} />
          <Route path="/legal/teilnahmebedingungen-treueprogramm" element={<TeilnahmebedingungenTreueprogrammPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
